/*
 * Copyright (c) to Energy Analytics & Solutions Pty Ltd. All rights reserved.
 */

import React from 'react'
import Nav from '../Navbar/Nav'
import cecmember from '../../assets/Images/cecmember.jpeg'
 import footerBg from '../../assets/Images/04.jpg'
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import Link from '@mui/material/Link';

const year = new Date().getFullYear()

const Footer = () => {
    return (

        <div className="footer" style={{
            background: `url(${footerBg}) center no-repeat`,
            backgroundSize: "100%"
        }}>
            <Nav />
            <div className="footerContactDetails">
                <div className="footerContactDetailsLeft">
                    <h3>CONTACT DETAILS</h3>
                    <div>E: <a href="mailto:info@energyanalyticssolutions.com">info@energyanalyticssolutions.com</a></div>
                    <div>P: <a href="tel:+61420510329">+61 420 510 329</a></div>
                    <div>1 Sergeants Lane, St. Leonards, NSW 2065</div>
                    <div className="footerContactDetailsLeft">
                        <Link
                            href="https://www.linkedin.com/company/energy-analytics-solutions/"
                            underline="none"
                            target="_blank"
                        >
                            <LinkedInIcon fontSize="medium">
                            </LinkedInIcon>
                        </Link>
                    </div>
                </div>

                <div>
                    
                    <div className="footerContactDetailsRight">
                        <img src={cecmember} alt="" />
                    </div>
                </div>
                
            </div>
            <div className="footerCopyright">
                Copyright &copy; {year} Energy Analytics & Solutions Pty Ltd. &nbsp; ABN: 60 650 339 763
            </div>
            <div className='lastgreenline'></div>
        </div>

    )
}

export default Footer

/*
 * Copyright (c) to Energy Analytics & Solutions Pty Ltd. All rights reserved.
 */